import { render, staticRenderFns } from "./MitigationGroupSettings.vue?vue&type=template&id=1f989f8c&scoped=true&"
import script from "./MitigationGroupSettings.vue?vue&type=script&lang=js&"
export * from "./MitigationGroupSettings.vue?vue&type=script&lang=js&"
import style0 from "./MitigationGroupSettings.vue?vue&type=style&index=0&id=1f989f8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f989f8c",
  null
  
)

export default component.exports